(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('ProfileCriterionItemSearch', ProfileCriterionItemSearch);

    ProfileCriterionItemSearch.$inject = ['$resource'];

    function ProfileCriterionItemSearch($resource) {
        var resourceUrl =  'api/_search/profile-criterion-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
